import {openTermAndPrivacy} from '@/libs/helper'

export default{
    name: 'ProhibitedBusiness',
    methods:{
        openPage(page){
            openTermAndPrivacy(page, true)
        }
    }
}